import React, { useState, useEffect } from "react";
import { NossosProdutos } from "../sections";
import { BannerHome } from "../sections/BannerHome";
import { Page } from "../../../components/shared/pages";
import SeguridadePageLayout from "../../../components/shared/layout/pageLayouts/seguridade";
import ModalSeguro from "../../../components/ModalSeguro/ModalSeguro";

export const HomePage = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const hasVisitedThisSession = sessionStorage.getItem(
      "hasVisitedThisSession"
    );

    if (!hasVisitedThisSession) {
      setTimeout(() => {
        setIsModalOpen(true);
        sessionStorage.setItem("hasVisitedThisSession", "true");
      }, 2000);
    }
  }, []);

  const handleCloseModal = () => setIsModalOpen(false);

  const handleContractClick = () => {
    handleCloseModal();
  };
  return (
    <Page id="page-home" {...props} banner={BannerHome} disabledCrumb>
      <SeguridadePageLayout.Tab eventKey="voce">
        <NossosProdutos sectionTitle="Nossos Produtos" />
      </SeguridadePageLayout.Tab>
        <ModalSeguro
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onContractClick={handleContractClick}
      />
    </Page>
  );
};

export default HomePage;
